import { ExamplePageTemplate } from "./components";
import { fitnessConfig } from "./configs/exampleConfigs";

const FitnessExample = () => {
  return (
    <ExamplePageTemplate
      backgroundColor={fitnessConfig.backgroundColor}
      chatButtonColor={fitnessConfig.chatButtonColor}
      chatButtonIcon={fitnessConfig.chatButtonIcon}
      header={fitnessConfig.header}
      hero={fitnessConfig.hero}
    >
      {fitnessConfig.content}
    </ExamplePageTemplate>
  );
};

export default FitnessExample;